export default featureName => stringOrObject => {
  if (typeof stringOrObject === "string") {
    return `${featureName}/${stringOrObject}`;
  }

  return { [featureName]: stringOrObject };
};
